<template>
  <div>

      <div class="filter">
        <div class="row">
          <div class="col-sm-4 p-2">
            <div class="search-row ">
               <input type="text" v-model="search" class="form-control" :placeholder="$t('videogalerry.search_placeholder')"/>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="search-row">
           
            </div>
          </div>
        </div>
      </div>
      <table id="music" class="table table-responsive table-hover">
        <thead>
          <tr class="myHead">
            <th v-for="item in header" :key="item">
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(video, idx) in filteredVideos"
              :key="video.id"
              :data-url="video.youtubeId"
              class="active-item">
            <td>{{ idx + 1 }}</td>
            <td>{{ video.title }}</td>
            <td>
              <button class="btn btn-info playBtn btn-primary" @click="playVideo(video.youtubeId)">Play <font-awesome-icon icon="fa-solid fa-circle-play" /></button>
            </td>
          </tr>
          <tr v-if="filteredVideos.length === 0">
            <td colspan="6" class="text-center">{{this.$t('videogalerry.no_videos_found')}}</td>
          </tr>
        </tbody>
      </table>
  
    <!-- Modal Video -->
    <div class="video_box" v-if="showModal" @click.self="closeModal">
      <div class="video_inner">
        <div class="modal-close" @click="closeModal">×</div>
        <div class="video_body">
          <iframe
            v-if="modalVideoId"
            :width="400"
            :height="250"
            :src="`${modalVideoId}?autoplay=1`"
            frameborder="0"
            allow="autoplay; fullscreen">
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['videos'],
  data() {
    return {
      header: ["#", this.$t('videogalerry.title_video'), this.$t('videogalerry.veprimet')],
      selectedCategory: '',
      search: '',
      showModal: false,
      modalVideoId: null,
    };
  },
  computed: {
    uniqueCategories() {
      return [...new Set(this.videos.map(v => v.category))];
    },
    filteredVideos() {
      let result = this.videos;
      if (this.selectedCategory) {
        result = result.filter(v => v.category === this.selectedCategory);
      }
      if (this.search) {
        const patt = new RegExp(this.search, 'i');
        result = result.filter(v => patt.test(v.title));
      }
      return result;
    },
  },
  methods: {
    playVideo(youtubeId) {
      this.modalVideoId = youtubeId;
      this.showModal = true;
      document.body.classList.add('modal-open');
    },
    closeModal() {
      this.showModal = false;
      this.modalVideoId = null;
      document.body.classList.remove('modal-open');
    },
  },
};
</script>


<style scoped>
.thumb {
    width: 70px;
    height: 50px;
    overflow: hidden;
    position: relative;
}
.table > tbody > tr > td {
     vertical-align: middle;
}

.video_box {
    background: rgba(0, 0, 0, 0.54);
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    position: fixed;
    z-index: 555;
    display: flex;
    align-items: center;
    justify-content: center;
}
.video_inner{
    position: relative;
    width: 430px;
    height: 280px;
    background: #fff;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.modal-close {
    position: absolute;
    top: 0;
    z-index: 5;
    background: #d64a4a;
    padding: 0px 11px;
    color: #fff;
    font-size: 30px;
    right: 0px;
    cursor: pointer;
}
.video_body{
    width: 400px;
    height: 250px;
}
.show-row {
  position: relative;
}
.show-row select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff url("data:image/svg+xml;utf8,<svg fill='gray' height='16' viewBox='0 0 24 24' width='16' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>") no-repeat right 12px center/18px 18px;
  padding-right: 36px;
  cursor: pointer;
}
</style>